/**
 * The ACH acknowledgement copy + version, shared by the add-vendor flow
 * (VendorFlyout) and the Payment Information tab's re-add flow (EX-40772). Kept
 * in its own leaf module so both the flyout and `useVendorPaymentMethod` can
 * import it without closing an import cycle (the flyout imports the hook, and
 * the hook needs this constant). `version` is the copy version sent on confirm;
 * `heading`/`description` are the visible acknowledgement copy — the phrase
 * "authorized for use" renders bold within the description in the markup.
 */
export const VENDOR_ACKNOWLEDGEMENT = {
  version: '2026-07-28',
  heading: 'I acknowledge that...',
  description:
    'These ACH account details are accurate and authorized for use when paying this vendor.',
} as const
